import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import { withRouter } from "react-router-dom"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

// services
import Staff from "services/staff/Staff"
import ApplicationService from "../../services/applications/Application.service"
import EnvAuditService from "services/applications/envAudit/EnvAuditService"

const staffService = new Staff()

const initialServices = [
  // officer
  { name: "Request for ToRs", key: "request_for_tor_applications", count: 0 },
  { name: "Drafted ToRs", key: "drafted_to_r", count: 0 },
  { name: "Waiting EA Report", key: "waiting_report", count: 0 },
  { name: "Report for Review", key: "for_review", count: 0 },
  { name: "Drafted EA Certificate", key: "drafted_certificate", count: 0 },
  { name: "Approved Certificate", key: "approved", count: 0 },
  { name: "Approved ToR Certificate", key: "approved_tor", count: 0 },
  { name: "All Applications", key: "all_applications", count: 0 },

  // Head
  { name: "Drafted ToRs", key: "draftedToRCount", count: 0 },
  { name: "New Applications", key: "submittedEnvironmentCount", count: 0 },
  { name: "DM Pending", key: "pendingEnvironmentCount", count: 0 },
  {
    name: "Drafted EA Certificate",
    key: "draftedEACertificateCount",
    count: 0,
  },
  { name: "Approved Certificate", key: "approvedEnvironmentCount", count: 0 },

  //   Director
  { name: "Drafted ToRs", key: "draftedToRCount", count: 0 },
  {
    name: "Drafted EA Certificate",
    key: "draftedEACertificateCount",
    count: 0,
  },
  { name: "Approved Certificate", key: "approvedEnvironmentCount", count: 0 },
]

const SidebarContent = props => {
  const ref = useRef()
  const user = JSON.parse(localStorage.getItem("authUser"))
  const auditService = new EnvAuditService(user)

  const [permissions, setpermissions] = useState([])
  const [isAdmin, setisAdmin] = useState(false)
  const [isOfficer, setisOfficer] = useState(false)
  const [isHoD, setisHoD] = useState(false)
  const [isDG, setisDG] = useState(false)
  const [mounted, setmounted] = useState(false)
  const [hodRoutes, sethodRoutes] = useState()
  const [pendingApplications, setPendingApplications] = useState()
  const [services, setServices] = useState(initialServices)

  let appService = null

  useEffect(() => {
    // fetch menu statistics
    if (user.position_id === 1) {
      fetchOfficerStatistics()
      setisOfficer(true)
    } else if (user.position_id === 2) {
      fetchHoDStatistics()
      setisHoD(true)
    } else if (user.position_id === 3) {
      fetchDGStatistics()
      setisDG(true)
    }

    appService = new ApplicationService(user)

    appService.getStatistics().then(response => {
      setPendingApplications(response.data.pending_applications)
      // console.log("Pending Applications", response.data.pending_applications)
    })
    staffService.getStaffDetails(user).then(response => {
      if (response.status) {
        var perms = []

        response.data.permissions.forEach(perm => {
          perms.push(perm.name)
        })
        setpermissions(perms)
        if (perms.includes("Administer Portal")) {
          setisAdmin(true)
        }
        setmounted(true)
      }
    })
  }, [])

  // Use ComponentDidMount and ComponentDidUpdate method symultaniously
  useEffect(() => {
    const pathName = props.location.pathname

    const initMenu = () => {
      new MetisMenu("#side-menu")
      let matchingMenuItem = null
      const ul = document.getElementById("side-menu")
      const items = ul.getElementsByTagName("a")
      for (let i = 0; i < items.length; ++i) {
        if (pathName === items[i].pathname) {
          matchingMenuItem = items[i]
          break
        }
      }
      if (matchingMenuItem) {
        activateParentDropdown(matchingMenuItem)
      }
    }
    initMenu()
  }, [props.location.pathname])

  useEffect(() => {
    ref.current.recalculate()
  })

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  function activateParentDropdown(item) {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }

  const fetchOfficerStatistics = () => {
    auditService.getOfficerStatistics().then(response => {
      if (response.status) {
        // console.log("stats", response.data)
        const data = response.data

        // Update services with the latest counts
        const updatedServices = initialServices.map(service => ({
          ...service,
          count: data[service.key] ?? 0, // Default to 0 if key is missing
        }))

        setServices(updatedServices)
      }
    })
  }

  const fetchHoDStatistics = () => {
    auditService.getDMStatistics().then(response => {
      if (response.status) {
        // console.log("stats head")
        const data = response.data

        // Update services with the latest counts
        const updatedServices = initialServices.map(service => ({
          ...service,
          count: data[service.key] ?? 0, // Default to 0 if key is missing
        }))

        setServices(updatedServices)
      }
    })
  }

  const fetchDGStatistics = () => {
    auditService.getDGStatistics().then(response => {
      if (response.status) {
        // console.log("stats", response)
        const data = response.data

        // Update services with the latest counts
        const updatedServices = initialServices.map(service => ({
          ...service,
          count: data[service.key] ?? 0, // Default to 0 if key is missing
        }))

        setServices(updatedServices)
      }
    })
  }

  const fetchApprovedToR = () => {
    auditService.getDGStatistics().then(response => {
      if (response.status) {
        // console.log("stats", response)
        const data = response.data

        // Update services with the latest counts
        const updatedServices = initialServices.map(service => ({
          ...service,
          count: data[service.key] ?? 0, // Default to 0 if key is missing
        }))

        setServices(updatedServices)
      }
    })
  }

  return (
    <React.Fragment>
      <SimpleBar style={{ maxHeight: "100%" }} ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("Main")} </li>
            <li>
              <Link to="/env-compliance-dashboard" className="waves-effect">
                <i className="ti-home" style={{ color: "cyan" }}></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>
            

            {isHoD ? (
              // { name: "Drafted ToRs", key: "draftedToRCount", count: 0 },
  // { name: "New Applications", key: "submittedEnvironmentCount", count: 0 },
              <li>
                 <Link
                  to="/dashboard-head-env-audit?filter=submittedEnvironmentCount"
                  className=" waves-effect"
                >
                  <i className="ti-shift-right" style={{ color: "white" }}></i>
                  <span>
                    {props.t("New Applications ")}{" "}
                    <span className="badge-success" style={{}}>
                      (
                      {services.find(
                        service => service.key === "submittedEnvironmentCount"
                      )?.count || 0}
                      )
                    </span>{" "}
                  </span>
                </Link>
                <Link
                  to="/dashboard-head-env-audit?filter=pendingEnvironmentCount"
                  className=" waves-effect"
                >
                  <i className="fa fa-tasks" style={{ color: "blue" }}></i>
                  <span>
                    {props.t("DM Pending ")}{" "}
                    <span className="badge-success" style={{}}>
                      (
                      {services.find(
                        service => service.key === "pendingEnvironmentCount"
                      )?.count || 0}
                      )
                    </span>{" "}
                  </span>
                </Link>
                <Link
                  to="/dashboard-head-env-audit?filter=draftedToRCount"
                  className=" waves-effect"
                >
                  <i className="ti-write" style={{ color: "red" }}></i>
                  <span>
                    {props.t("Drafted ToRs ")}{" "}
                    <span className="badge-success" style={{}}>
                      (
                      {services.find(
                        service => service.key === "draftedToRCount"
                      )?.count || 0}
                      )
                    </span>{" "}
                  </span>
                </Link>
                <Link
                  to="/dashboard-head-env-audit?filter=draftedEACertificateCount"
                  className=" waves-effect"
                >
                  <i className="fa fa-rocket" style={{ color: "pink" }}></i>
                  <span>{props.t("Drafted EA Certificate ")}</span>
                  <span className="badge-success" style={{}}>
                    (
                    {services.find(
                      service => service.key === "draftedEACertificateCount"
                    )?.count || 0}
                    )
                  </span>
                </Link>
                <Link
                  to="/dashboard-head-env-audit?filter=approvedEnvironmentCount"
                  className=" waves-effect"
                >
                  <i className="fa ti-check" style={{ color: "green" }}></i>
                  <span>{props.t("Approved ")}</span>
                  <span className="badge-success" style={{}}>
                    (
                    {services.find(
                      service => service.key === "approvedEnvironmentCount"
                    )?.count || 0}
                    )
                  </span>
                </Link>

                <Link to="/staff" className=" waves-effect">
                  <i className="fa fa-users"></i>
                  <span>{props.t("Manage Staff")}</span>
                </Link>

                <Link to="/hod-reports" className=" waves-effect">
                  <i className="ti-book"></i>
                  <span>{props.t("Reports")}</span>
                </Link>
              </li>
            ) : (
              ""
            )}

            {isOfficer ? (
              <li>
                <Link
                  to="/dashboard-officer-env-audit?filter=request_for_tor_applications"
                  className=" waves-effect"
                >
                  <i className="fa fa-tasks" style={{ color: "blue" }}></i>
                  <span>{props.t("Requested ToRs ")}</span>
                  <span className="badge-success" style={{}}>
                    (
                    {services.find(
                      service => service.key === "request_for_tor_applications"
                    )?.count || 0}
                    )
                  </span>{" "}
                </Link>
                <Link
                  to="/dashboard-officer-env-audit?filter=drafted_to_r"
                  className=" waves-effect"
                >
                  <i className="fa fa-rocket" style={{ color: "pink" }}></i>
                  <span>{props.t("Drafted ToRs ")}</span>
                  <span className="badge-success" style={{}}>
                    (
                    {services.find(service => service.key === "drafted_to_r")
                      ?.count || 0}
                    )
                  </span>{" "}
                </Link>
                <Link
                  to="/dashboard-officer-env-audit?filter=waiting_report"
                  className=" waves-effect"
                >
                  <i className="fa fa-stop" style={{ color: "yellow" }}></i>
                  <span>{props.t("Waiting EA Report ")}</span>
                  <span className="badge-success" style={{}}>
                    (
                    {services.find(service => service.key === "waiting_report")
                      ?.count || 0}
                    )
                  </span>{" "}
                </Link>
                <Link
                  to="/dashboard-officer-env-audit?filter=for_review"
                  className=" waves-effect"
                >
                  <i className="fa fa-file" style={{ color: "orange" }}></i>
                  <span>{props.t("Report for Review ")}</span>
                  <span className="badge-success" style={{}}>
                    (
                    {services.find(service => service.key === "for_review")
                      ?.count || 0}
                    )
                  </span>{" "}
                </Link>
                {/* drafted_certificate */}
                <Link
                  to="/dashboard-officer-env-audit?filter=drafted_certificate"
                  className=" waves-effect"
                >
                  <i className="ti-check" style={{ color: "green" }}></i>
                  <span>{props.t("Drafted EA Certificate ")}</span>
                  <span className="badge-success" style={{}}>
                    (
                    {services.find(service => service.key === "drafted_certificate")
                      ?.count || 0}
                    )
                  </span>{" "}
                </Link>
                <Link
                  to="/dashboard-officer-env-audit?filter=approved"
                  className=" waves-effect"
                >
                  <i className="ti-check" style={{ color: "green" }}></i>
                  <span>{props.t("Approved Certificate ")}</span>
                  <span className="badge-success" style={{}}>
                    (
                    {services.find(service => service.key === "approved")
                      ?.count || 0}
                    )
                  </span>{" "}
                </Link>
              </li>
            ) : null}

            {isDG ? (
              <li>
                <Link
                  to="/dashboard-director-env-audit?filter=draftedToRCount"
                  className=" waves-effect"
                >
                  <i className="fa fa-tasks" style={{ color: "blue" }}></i>
                  <span>
                    {props.t("Drafted ToRs ")}{" "}
                    <span className="badge-success" style={{}}>
                      (
                      {services.find(
                        service => service.key === "draftedToRCount"
                      )?.count || 0}
                      )
                    </span>{" "}
                  </span>
                </Link>
                <Link
                  to="/dashboard-director-env-audit?filter=draftedEACertificateCount"
                  className=" waves-effect"
                >
                  <i className="fa fa-rocket" style={{ color: "pink" }}></i>
                  <span>{props.t("Drafted EA Certificate ")}</span>
                  <span className="badge-success" style={{}}>
                    (
                    {services.find(
                      service => service.key === "draftedEACertificateCount"
                    )?.count || 0}
                    )
                  </span>
                </Link>
                <Link
                  to="/dashboard-director-env-audit?filter=approvedEnvironmentCount"
                  className=" waves-effect"
                >
                  <i className="fa ti-check" style={{ color: "white" }}></i>
                  <span>{props.t("Approved ")}</span>
                  <span className="badge-success" style={{}}>
                    (
                    {services.find(
                      service => service.key === "approvedEnvironmentCount"
                    )?.count || 0}
                    )
                  </span>
                </Link>

                <Link to="/hod-reports" className=" waves-effect">
                  <i className="ti-book"></i>
                  <span>{props.t("Reports")}</span>
                </Link>
              </li>
            ) : null}
            <li>
              <Link to="/tor-approved" className=" waves-effect">
                <i className="ti-check-box" style={{ color: "white" }}></i>
                <span>{props.t("ToR Approved ")}</span>
                <span className="badge-success" style={{}}>
                  (
                  {services.find(service => service.key === "approved_tor")
                    ?.count || 0}
                  )
                </span>{" "}
              </Link>
            </li>
            <li>
              <Link to="/all-env-applications" className=" waves-effect">
                <i className="ti-world" style={{ color: "purple" }}></i>
                <span>{props.t("All Applications ")}</span>
                <span className="badge-success" style={{}}>
                  (
                  {services.find(service => service.key === "all_applications")
                    ?.count || 0}
                  )
                </span>{" "}
              </Link>
            </li>
            {isAdmin ? (
              <li>
                <Link to="/staff" className=" waves-effect">
                  <i className="fa fa-users"></i>
                  <span>{props.t("Manage Staff")}</span>
                </Link>

                <Link to="/configurations" className=" waves-effect">
                  <i className="ti ti-settings"></i>
                  <span>{props.t("Configurations")}</span>
                </Link>
              </li>
            ) : null}
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
